export default __webpack_public_path__ + "static/media/person.977d1a39.png";